import { i18n } from '../../../language';
import { getCurrentLanguage } from '../../../utils/languageDetector';
import { CHANGE_LANGUAGE, CLOSE_FULL_SCREEN, CLOSE_WORKFLOW, OPEN_FULL_SCREEN, OPEN_WORKFLOW } from '../../constant';

const initialState = {
  language: getCurrentLanguage(),
};

const SettingsReducer = (state = initialState, action) => {
  const { type, language } = action;
  if (type === CHANGE_LANGUAGE) {
    i18n.locale = language;
    return { ...state, ...{ language } };
  } else {
    return state;
  }
};

const fullScreenReducer = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case CLOSE_FULL_SCREEN:
      return false;
    case OPEN_FULL_SCREEN:
      return true;
    default:
      return state;
  }
};

const AdmissionWorkflowReducer = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case CLOSE_WORKFLOW:
      return false;
    case OPEN_WORKFLOW:
      return true;
    default:
      return state;
  }
};

export default SettingsReducer;
export { SettingsReducer, fullScreenReducer, AdmissionWorkflowReducer };
